import { render } from "./RsdCopyToClipboard.vue?vue&type=template&id=9c2f46dc&scoped=true"
import script from "./RsdCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./RsdCopyToClipboard.vue?vue&type=script&lang=js"

import "./RsdCopyToClipboard.vue?vue&type=style&index=0&id=9c2f46dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9c2f46dc"

export default script